import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router/index.js";
import axios from "axios";
import VueI18n from "vue-i18n";
import store from "./store/index.js"
// /var/www/html/iskola-canteen-frontend/src/store/index.js;
// eslint-disable-next-line no-unused-vars
import localization from "./localization.js";
// import ar from "./translations/ar.json";
// import en from "./translations/en.json";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "./assets/css/all.min.css"; // Fontawesome CSS
Vue.use(VueI18n);
// export const i18n = new VueI18n({
//   locale: "en",
//   fallbackLocale: "en",
//   messages: {
//     ar: ar,
//     en: en,
//   },
//   silentTranslationWarn: true,
// });

// Vue.use(VueI18n);
export const i18n = new VueI18n({
  locale:
    localStorage.locale === "ar" || window.location.search.includes("?lang=ar")
      ? "ar"
      : "en",
  fallbackLocale: "en",
  messages: localization,
  silentTranslationWarn: true,
});

import "./custom-style.css";

Vue.prototype.$http = axios;

Vue.config.productionTip = false;

import { mapGetters } from "vuex";
// import { BreadCrumbMixin } from "@/mixins/BreadCrumbMixin";
Vue.mixin({
  // mixins: [BreadCrumbMixin],
  data() {
    return {
      currentAppLocale:
        localStorage.locale === "ar" ||
          window.location.search.includes("?lang=ar")
          ? "ar"
          : "en",
    };
  },
  computed: {
    ...mapGetters([
      "getApiUrl",
      "getBackEndUrl",
      "getSideBarMin",
      "getSidebarDisplay",
    ]),
  },
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

// new Vue({
//   router,
//   store,
//   vuetify,
//   i18n,
//   render: (h) => h(App),
// }).$mount("#app");

// add locale using axios intereceptors to all requests
axios.interceptors.request.use(
  function (config) {
    config.headers["locale"] =
      localStorage.locale != undefined ? localStorage.locale : "en";
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
